<template>
  <section class="message-tips">
    <p class="message-tips__title" data-test-id="message-tips-message">
      <slot />
    </p>
    <p class="message-tips__content">
      <span data-test-id="message-tips-tips-message">{{ tipsMessage }}</span>
      <ul class="message-tips__tips" data-test-id="message-tips-tips">
        <li v-for="tip in tips" :key="tip">
          {{ tip }}
        </li>
      </ul>
    </p>
  </section>
</template>

<script>
import { isArrayOfStrings } from '~~/common/js/universal/validators';

export default {
  name: 'EMessageTips',
  props: {
    tipsMessage: {
      type: String,
      required: true,
    },
    tips: {
      type: Array,
      required: true,
      validator: isArrayOfStrings,
    },
  },
};
</script>

<style lang="scss" scoped>
.message-tips {
  font-size: $font-m;
}

.message-tips__title,
.message-tips__content {
  margin: 0;
}

.message-tips__title {
  font-size: $font-l;
}

.message-tips__content {
  margin-top: $space-s;
}

.message-tips__tips {
  margin: $space-1s 0 0;
  padding: 0;
  list-style-position: inside;
}
</style>
